module.exports = "\n<app-registry *ngIf=!showWebsite></app-registry>\n<app-website  *ngIf=showWebsite [siteName]=\"registryName\" [useDefaultData]=\"false\" [website]=\"website\" [registry]=\"registry\"></app-website>"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/landing.component.html
// module id = ./src/app/landing/landing.component.html
// module chunks = main